import {useRouteMatch, Switch, Route, Redirect} from 'react-router-dom';

import Customers from './Customers';
import Employees from './Employees';
import Teams from './Teams';
import Vendors from './Vendors';
import useCompanyConfig from 'hooks/useCompanyConfig';

function ResellerRoute({children}: {children: React.ReactElement}) {
  const {isPickupDropoff} = useCompanyConfig();
  const {path} = useRouteMatch();
  if (isPickupDropoff) {
    return children;
  }
  return <Redirect to={`${path}/customers`} />;
}

function Settings() {
  const {path} = useRouteMatch();

  return (
    <>
      <Switch>
        <Route path={`${path}/customers`} exact component={Customers} />
        <Route
          path={`${path}/vendors`}
          exact
          component={() => (
            <ResellerRoute>
              <Vendors />
            </ResellerRoute>
          )}
        />
        <Route path={`${path}/employees`} exact component={Employees} />
        <Route path={`${path}/teams`} exact component={Teams} />
        <Redirect to={`${path}/customers`} />
      </Switch>
    </>
  );
}

export default Settings;
